import React, { memo } from 'react';
import NextLink from 'next/link';

import { HeaderNav } from './styles';
import Text from '../common/text';
import { BLOG_LINK, MANIFESTO_LINK } from 'constants/links';

function HeaderNavigation() {
  return (
    <HeaderNav className="header-nav">
      <NextLink href={MANIFESTO_LINK} passHref>
        <a target="_blank">
          <Text>Manifesto</Text>
        </a>
      </NextLink>
      <NextLink href={BLOG_LINK} passHref>
        <a target="_blank">
          <Text>Blog</Text>
        </a>
      </NextLink>
    </HeaderNav>
  );
}

export default memo(HeaderNavigation);
